import React, { useState } from "react";
import { Box, Typography, Grid, Card, CardContent, Button, Chip, Divider, Table, TableHead, TableRow, TableCell, TableBody, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import OlympiadRegistrationPDF from "./modals/OlympiadRegistrationPDF";

const ViewOlympiadRegistrationModal = ({ closePopup, modalData }) => {
    const data = modalData?.data || modalData;
    const [modal, setModal] = useState(false);
    const [pdfData, setPdfData] = useState(null);

    const getClassNumber = (className) => {
        const match = className?.match(/\d+/);
        return match ? parseInt(match[0], 10) : 0;
    };

    const formatDate = (date) =>
        date ? new Date(date).toLocaleString() : "N/A";

    const uniqueCoordinators = [
        ...new Map(data?.coordinators?.map((c) => [c.email, c])).values()
    ];
    const groupedSubjects = data?.lineItems?.reduce((acc, item) => {
        const key = item.subjectName;

        if (!acc[key]) acc[key] = [];

        acc[key].push(item);

        return acc;
    }, {});

    const fetchOlympiadMOMSummaryAPI = async () => {
        try {

            console.log("Fetching MOM Summary API with:", {
                regId: data?.regId,
                partyId: data?.partyId
            });
            const result = await window.Platform.database.getMOMSummaryAPI({
                regId: data?.regId,
                partyId: data?.partyId
            });

            console.log("MOM Summary API Result:", result);

            if (result?.status && result?.data) {
                setPdfData(result.data);

                // ✅ FINAL PDF CALL
                OlympiadRegistrationPDF(result.data);
            } else {
                console.warn("No data from API");
            }

        } catch (err) {
            console.error("API Error:", err);
        }
    };
    return (
        // <Box p={2} sx={{ backgroundColor: "#fff", position: "relative" }}>
        <Box sx={{ backgroundColor: "#fff", height: "100%", display: "flex", flexDirection: "column" }}>

            <Box
                sx={{
                    position: "sticky",
                    top: -20,
                    zIndex: 10,
                    backgroundColor: "#fff",
                    borderBottom: "1px solid #ddd",
                    px: 2,
                    py: 1.5,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                }}
            >
                {/* HEADER */}
                <Typography variant="h5">
                    <b>Olympiad Details: - </b> {data?.schoolName} ({data?.partyId})
                </Typography>

                <IconButton
                    onClick={closePopup}
                // sx={{ position: "absolute", right: 8, top: 8 }}
                >
                    <CloseIcon />
                </IconButton>
            </Box>
            <Box sx={{ flex: 1, overflowY: "auto", p: 2 }}>
                {/* 🔹 Coordinators */}
                <Box mb={3}>
                    <Typography variant="h6" mb={1}>
                        Coordinator Details
                    </Typography>

                    <Table size="small" sx={{ backgroundColor: "#fff" }}>
                        <TableHead>
                            <TableRow>
                                <TableCell style={{ color: "#fff" }}><b>S.No</b></TableCell>
                                <TableCell style={{ color: "#fff" }}><b>Subject</b></TableCell>
                                <TableCell style={{ color: "#fff" }}><b>Coordinator Name</b></TableCell>
                                <TableCell style={{ color: "#fff" }}><b>Mobile</b></TableCell>
                                <TableCell style={{ color: "#fff" }}><b>Email</b></TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {data?.coordinators?.length > 0 ? (
                                data.coordinators.map((c, i) => (
                                    <TableRow key={c.id}>
                                        <TableCell>{i + 1}</TableCell>
                                        <TableCell>{c.subject_name}</TableCell>
                                        <TableCell>{c.name}</TableCell>
                                        <TableCell>{c.mobile}</TableCell>
                                        <TableCell>{c.email}</TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={5} align="center">
                                        No Coordinator Found
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </Box>

                <Divider sx={{ mb: 2 }} />

                {/* 🔹 Line Items */}
                <Grid container spacing={2}>
                    {Object.entries(groupedSubjects || {}).map(([subject, items], idx) => {

                        const totalRegAmount = items.reduce(
                            (sum, i) => sum + ((i.student || 0) * (i.registrationFee || 0)),
                            0
                        );

                        const totalSMCount = items.reduce(
                            (sum, i) => sum + (i.study_material ? (i.student || 0) : 0),
                            0
                        );

                        const totalSMAmount = items.reduce(
                            (sum, i) =>
                                sum + (i.study_material ? (i.student || 0) * (i.subjectAmount || 0) : 0),
                            0
                        );

                        const grandTotal = totalRegAmount + totalSMAmount;

                        // totals
                        const totalStudents = items.reduce((sum, i) => sum + (i.student || 0), 0);
                        const totalMaterial = items.reduce((sum, i) => sum + (i.study_material || 0), 0);

                        return (
                            <Grid item xs={12} key={idx}>
                                <Card sx={{ borderRadius: 2 }}>
                                    <CardContent>

                                        {/* 🔹 SUBJECT HEADER */}
                                        <Typography variant="h6" mb={1}>
                                            Subject: {subject}
                                        </Typography>

                                        <Table size="small">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell style={{ color: "#fff" }}><b>Class</b></TableCell>
                                                    <TableCell style={{ color: "#fff" }}><b>Students</b></TableCell>
                                                    <TableCell style={{ color: "#fff" }}><b>Registration Fee</b></TableCell>
                                                    <TableCell style={{ color: "#fff" }}><b>Study Material</b></TableCell>
                                                    <TableCell style={{ color: "#fff" }}><b>Study Material Count</b></TableCell>
                                                    <TableCell style={{ color: "#fff" }}><b>Study Material Fee</b></TableCell>
                                                    <TableCell style={{ color: "#fff" }}><b>Amount</b></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {/* {items.map((item, i) => { */}
                                                {[...items]
                                                    .sort((a, b) => getClassNumber(a.className) - getClassNumber(b.className))
                                                    .map((item, i) => {

                                                        const regAmount = (item.student || 0) * (item.registrationFee || 0);
                                                        const smCount = item.study_material ? item.student : 0;
                                                        const smAmount = smCount * (item.subjectAmount || 0);
                                                        const totalAmount = regAmount + smAmount;

                                                        return (
                                                            <TableRow key={i}>
                                                                <TableCell>{item.className}</TableCell>

                                                                <TableCell>{item.student}</TableCell>

                                                                <TableCell>₹{regAmount}</TableCell>

                                                                <TableCell>
                                                                    <Chip
                                                                        label={item.study_material ? "Yes" : "No"}
                                                                        size="small"
                                                                        color={item.study_material ? "success" : "default"}
                                                                    />
                                                                </TableCell>

                                                                <TableCell>{smCount}</TableCell>

                                                                <TableCell>₹{smAmount}</TableCell>

                                                                <TableCell><b>₹{totalAmount}</b></TableCell>
                                                            </TableRow>
                                                        );
                                                    })}
                                                <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                                                    <TableCell><b>Total</b></TableCell>

                                                    <TableCell><b>{totalStudents}</b></TableCell>

                                                    <TableCell><b>₹{totalRegAmount}</b></TableCell>

                                                    <TableCell></TableCell>

                                                    <TableCell><b>{totalSMCount}</b></TableCell>

                                                    <TableCell><b>₹{totalSMAmount}</b></TableCell>

                                                    <TableCell><b>₹{grandTotal}</b></TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>

                                    </CardContent>
                                </Card>
                            </Grid>
                        );
                    })}
                </Grid>
                <div style={{ display: "flex", justifyContent: "space-between", marginTop: "20px" }}>
                    <Button
                        variant="contained"
                        color="success"
                        onClick={fetchOlympiadMOMSummaryAPI}
                    >
                        Download PDF
                    </Button>

                    <Button variant="contained" color="warning" onClick={closePopup}>
                        Close
                    </Button>
                </div>
            </Box>
        </Box>
    );
};

export default ViewOlympiadRegistrationModal;